export const FALSE_VALUES = ['false', false, null, undefined];

export function castBoolean(value: boolean | unknown): boolean {
  return !FALSE_VALUES.includes(value as boolean);
}
